module.exports = __webpack_public_path__ + "static/media/pushpin.8cd92546.svg";